import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HeaderCustRight } from './../header-custright';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import { formatCustRight } from '@core/_utils/tools.utils';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-edit-custrights',
    templateUrl: './edit-custrights.component.html',
    styleUrls: ['./edit-custrights.component.scss'],
})
export class EditCustRightsComponent implements OnInit {
    public selectedResult: HeaderCustRight;
    public resultResult: any[];

    @Input()
    public item: any;

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Input()
    public screenList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDeleteItem: EventEmitter<any> = new EventEmitter();

    constructor(
        private translate: TranslateService,
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService
    ) {
        this.menu.display = true;
        this.selectedResult = new HeaderCustRight();
    }

    ngOnInit() {
        this.getResult(this.item.id);
        this.commonService.checkReset();
    }

    private async getResult(id) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getcustomright', id ));
            this.resultResult = wRes.data;
            this.resultResult[0].typeitem = this.resultResult[0].typeitem === 1 ? true : false;
            this.selectedResult.Clear();
            if (id !== 0) {
                this.loadResultData(this.resultResult[0]);
            }            
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));	
        }
    }

    private loadResultData(adata) {
        this.selectedResult.load(adata);
    }

    delete(data) {
        this.onDeleteItem.emit({ index: this.item.index, id: this.item.id, data: data });
    }

    public async validate(aData) {
        let wRes: any = {};
        const wdata = formatCustRight(aData);
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('setcustomright', wdata ));
            this.onValidate.emit({ index: this.item.index, id: this.item.id, data: wRes.data });               
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        } 
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
